// extracted by mini-css-extract-plugin
export default {"cover":"connect_cover__ynEvf","connect":"connect_connect__yAThP","image":"connect_image__EMdLN","text":"connect_text__S-8hF"};